import { render } from "./drawingBoard.vue?vue&type=template&id=0a936f50&scoped=true"
import script from "./drawingBoard.vue?vue&type=script&lang=js"
export * from "./drawingBoard.vue?vue&type=script&lang=js"

import "./drawingBoard.vue?vue&type=style&index=0&id=0a936f50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a936f50"]])

export default __exports__